import { PureComponent } from 'react';

import type { GetReferralDashboardData } from '../graphql/queries/__generated__/GetReferralDashboardData';
import { ContentCard } from './ContentCard';
import { ContentWrapper } from './ContentWrapper';
import ReferralLink from './ReferralLink';

import styles from '../styles/ReferCustomersSectionStyle.module.css';

class ReferCustomersSection extends PureComponent<GetReferralDashboardData> {
  public override render() {
    const { organization } = this.props;

    return (
      <ContentWrapper>
        <ContentCard title="Refer Customers To Opendoor">
          <div className={styles.description}>
            Share this link with buyers who have a home to sell. Once they request an offer from
            Opendoor with this link, you can follow their progress below.
          </div>
          <div className={`${styles['referral-link']} large-margin-top medium-margin-bottom`}>
            <ReferralLink url={organization?.referralUrl as string} />
          </div>
        </ContentCard>
      </ContentWrapper>
    );
  }
}

export default ReferCustomersSection;
